export const HOMEPAGE_PATHS = [
  "/tax",
  "/tax/",
  "/v2/filings-dashboard",
  "/books",
  "/books/",
];
